var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNavbarOpen = function SvgNavbarOpen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 30,
    stroke: "currentColor",
    strokeWidth: 2
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1h40M0 15h40M0 29h40"
  })));
};
export { SvgNavbarOpen as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0nNDAnIGhlaWdodD0nMzAnIHZpZXdCb3g9IjAgMCA0MCAzMCIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS13aWR0aD0iMiIgIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPGc+CiAgICA8bGluZSB4MT0iMCIgeTE9IjEiIHgyPSI0MCIgeTI9IjEiIC8+CiAgICA8bGluZSB4MT0iMCIgeTE9IjE1IiB4Mj0iNDAiIHkyPSIxNSIgLz4KICAgIDxsaW5lIHgxPSIwIiB5MT0iMjkiIHgyPSI0MCIgeTI9IjI5IiAvPgogIDwvZz4KPC9zdmc+Cg==";